import { makeStyles } from '@material-ui/core'

const styles = (secondaryColor) =>
  makeStyles((theme) => ({
    logo: {
      position: 'fixed',
      bottom: theme.spacing(3),
      left: theme.spacing(3),
      width: 200,
    },
    detailBottomRight: {
      position: 'fixed',
      bottom: 0,
      right: 0,
      zIndex: 0,
      ...(secondaryColor && {
        '& path': { stroke: `${secondaryColor} !important` },
      }),
    },
    detailTopLeft: {
      position: 'fixed',
      top: 0,
      left: 0,
      transform: 'rotate(180deg)',
      zIndex: theme.zIndex.appBar + 1,
      ...(secondaryColor && {
        '& path': { stroke: `${secondaryColor} !important` },
      }),
    },
    logoutButton: {
      position: 'fixed',
      top: 68,
      right: theme.spacing(3),
      backgroundColor: theme.palette.common.white,
      zIndex: theme.zIndex.drawer + 1,
      padding: theme.spacing(1, 3),
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
    content: {
      paddingTop: 'calc(var(--dpoday-banner-height, 0px) + 68px)',
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(2),
      padding: theme.spacing(0, 2),
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        overflowY: 'auto',
        paddingBottom: theme.spacing(4),
      },
    },
  }))

export default styles
